
import React, { useState } from 'react';
import { Typography, Button, Box, CircularProgress } from '@mui/material';
import axios from 'axios';

const QRCodeGenerator = () => {
  const [qrCode, setQrCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateQRCode = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      
      const response = await axios.get('https://hub2.daolog.net/generate-totp-qr');
      
      setQrCode(response.data.qrCodeUrl);
    } catch (err) {
      console.error('Помилка отримання QR-коду:', err);
      setError('Помилка отримання QR-коду: ' + (err.response?.data?.message || err.message));
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <Box sx={{ width: '100%', textAlign: 'center', marginTop: 2 }} style={{ marginTop: '20px' }}>
       <Typography variant="h5" gutterBottom>
        Google Authenticator QR-код
      </Typography>
      
      <Typography variant="body1" gutterBottom>
        Натисніть кнопку, щоб згенерувати QR-код для Google Authenticator
      </Typography>
      
      <Button
        variant="contained"
        color="primary"
        onClick={generateQRCode}
        disabled={isLoading}
        sx={{ margin: '20px 0' }}
      >
        {isLoading ? <CircularProgress size={24} /> : 'Згенерувати QR-код'}
      </Button>
      
      {error && (
        <Typography variant="body2" color="error" gutterBottom>
          {error}
        </Typography>
      )}
      
      {qrCode && !isLoading && (
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center',
          margin: '20px 0'
        }}>
          <Typography variant="body2" gutterBottom>
            Відскануйте QR-код у додатку Google Authenticator
          </Typography>
          <img src={qrCode} alt="Google Auth QR Code" style={{ width: '200px', height: '200px' }} />
        </Box>
      )}
    </Box>
  );
};

export default QRCodeGenerator;